// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px; }

.products-modal-container {
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column; }

.products-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa; }
  .products-modal-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: #262626; }

.products-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  font-size: 14px; }
  .products-modal-close:hover {
    background-color: #f5f5f5;
    color: #595959; }

.products-modal-content {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1; }

.customer-info {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  text-align: center;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border-left: 3px solid #1890ff; }
  .customer-info strong {
    color: #333;
    font-weight: 600; }

.products-table .ant-table {
  border: 1px solid #f0f0f0;
  border-radius: 6px; }

.products-table .ant-table-thead > tr > th {
  background-color: #fafafa;
  font-weight: 600;
  color: #262626; }

.products-table .ant-table-tbody > tr > td {
  padding: 12px 16px; }

.products-table .ant-table-tbody > tr:hover > td {
  background-color: #f5f5f5; }

.no-products {
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 16px;
  background-color: #fafafa;
  border-radius: 6px;
  border: 2px dashed #d9d9d9; }

/* Responsive design */
@media (max-width: 768px) {
  .products-modal-overlay {
    padding: 10px; }
  .products-modal-container {
    max-width: 100%;
    max-height: 90vh; }
  .products-modal-content {
    padding: 16px; }
  .products-modal-header {
    padding: 12px 16px; } }
`, "",{"version":3,"sources":["webpack://./src/components/ProductsModal/style.scss"],"names":[],"mappings":"AAAA;EACI,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa,EAAA;;AAGjB;EACI,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAA;;AAG1B;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB,EAAA;EANvB;IASQ,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAA;;AAItB;EACI,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe,EAAA;EAVnB;IAaQ,yBAAyB;IACzB,cAAc,EAAA;;AAItB;EACI,aAAa;EACb,gBAAgB;EAChB,SAAO,EAAA;;AAGX;EACI,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B,EAAA;EARlC;IAWQ,WAAW;IACX,gBAAgB,EAAA;;AAIxB;EAEQ,yBAAyB;EACzB,kBAAkB,EAAA;;AAH1B;EAOQ,yBAAyB;EACzB,gBAAgB;EAChB,cAAc,EAAA;;AATtB;EAaQ,kBAAkB,EAAA;;AAb1B;EAiBQ,yBAAyB,EAAA;;AAIjC;EACI,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B,EAAA;;AAG9B,sBAAA;AACA;EACI;IACI,aAAa,EAAA;EAGjB;IACI,eAAe;IACf,gBAAgB,EAAA;EAGpB;IACI,aAAa,EAAA;EAGjB;IACI,kBAAkB,EAAA,EACrB","sourcesContent":[".products-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 20px;\n}\n\n.products-modal-container {\n    background: white;\n    border-radius: 6px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    max-width: 600px;\n    width: 100%;\n    max-height: 80vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.products-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 24px;\n    border-bottom: 1px solid #f0f0f0;\n    background: #fafafa;\n\n    h3 {\n        margin: 0;\n        font-size: 16px;\n        font-weight: 500;\n        color: #262626;\n    }\n}\n\n.products-modal-close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #8c8c8c;\n    font-size: 14px;\n\n    &:hover {\n        background-color: #f5f5f5;\n        color: #595959;\n    }\n}\n\n.products-modal-content {\n    padding: 24px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.customer-info {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 20px;\n    text-align: center;\n    padding: 12px;\n    background-color: #f9f9f9;\n    border-radius: 4px;\n    border-left: 3px solid #1890ff;\n\n    strong {\n        color: #333;\n        font-weight: 600;\n    }\n}\n\n.products-table {\n    .ant-table {\n        border: 1px solid #f0f0f0;\n        border-radius: 6px;\n    }\n\n    .ant-table-thead > tr > th {\n        background-color: #fafafa;\n        font-weight: 600;\n        color: #262626;\n    }\n\n    .ant-table-tbody > tr > td {\n        padding: 12px 16px;\n    }\n\n    .ant-table-tbody > tr:hover > td {\n        background-color: #f5f5f5;\n    }\n}\n\n.no-products {\n    text-align: center;\n    padding: 60px 20px;\n    color: #999;\n    font-size: 16px;\n    background-color: #fafafa;\n    border-radius: 6px;\n    border: 2px dashed #d9d9d9;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n    .products-modal-overlay {\n        padding: 10px;\n    }\n\n    .products-modal-container {\n        max-width: 100%;\n        max-height: 90vh;\n    }\n\n    .products-modal-content {\n        padding: 16px;\n    }\n\n    .products-modal-header {\n        padding: 12px 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
